<template>
  <div
    :class="{
      'no-wrap': dense && tiny,
      'q-col-gutter-sm': dense && tiny,
      'q-col-gutter-md': !dense || !tiny
    }"
    class="row"
  >
    <span
      v-for="target in sortedTargets"
      :key="target.id"
    >
      <target-data
        ref="targets"
        :session-program="sessionProgram"
        :target="target"
        :data="data"
        :active-prompt-levels="activePromptLevels"
        :workflow-statuses="workflowStatuses"
        :dense="dense"
        :tiny="tiny"
        :disable="disable"
        :session-paused="sessionPaused"
        :session-duration-offset="sessionDurationOffset"
        :cached-current-program-trial="cachedCurrentProgramTrial"
        @record="onRecord"
        @record-program-data="onRecordProgramData"
      />
    </span>
  </div>
</template>
<script>

import TargetData from 'components/Programs/DataCollection/TargetData';
import { chain, isEmpty } from 'lodash';
import DataCollectionProgram from 'src/mixins/DataCollectionProgram';

export default {
  name: 'GenericProgram',

  components: {
    TargetData,
  },

  mixins: [DataCollectionProgram],

  props: {
    cachedCurrentProgramTrial: {
      type: Number,
      default: 0,
    },
  },

  methods: {

    finishSession() {
      const finalData = chain(this.$refs)
        .get('targets')
        .map((targetRef) => {
          if (chain(targetRef).get('finishSession').isFunction().value()) {
            return targetRef.finishSession();
          }
          return null;
        })
        .flatten()
        .compact()
        .value();

      if (!isEmpty(finalData)) {
        return { finalData };
      }
    },

    undoData(undoDataItem) {
      const targetsRefs = this.$refs?.targets;

      if (Array.isArray(targetsRefs)) {
        const currentTargetRef = targetsRefs.find(
          (targetRef) => targetRef?.target?.id === undoDataItem.target,
        );

        if (typeof currentTargetRef?.undoData === 'function') {
          return currentTargetRef.undoData(undoDataItem);
        }
      }

      return true;
    },

  },
};
</script>
